import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const lytxv3Config: TSPConfig = {
  key: 'lytxv3',
  name: 'LytxV3',
  imageName: 'Lytx',
  category: TSPCategory.CREDENTIALS,
  helpText: 'Please provide your LytxV3 credentials.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default lytxv3Config;
